import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar.js";
import { Topbar } from "./Topbar.js";

export function AppShell() {
  return (
    <div className="se-app">
      <Sidebar />
      <main className="se-main">
        <Topbar />
        <div className="se-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
